export const LOCAL_STORAGE_KEYS = {
  USER: "user",
  LANGUAGE: "lang",
  COMPANY_ID: "company_id",
  LOCATIONS_IMPORT_STATUS: "loc_imp_status",
  HIDE_AUTO_CATEGORIZE_DIALOG: "hide_auto_categorize_dialog",
  DEMO_USER: "demo_user",
  CLIENT_ID: "client_id",
  SESSION_ID: "session_id"
};
